import { Modal } from 'react-bootstrap';
import { Component } from 'react';
import { connect } from 'react-redux';
import { baseUrl, showAddAccountAlertNew } from '../../../../../../utils';
import { FontAwesomeIcon } from '../../../../../CommonComponents/AssetsHelper';


class AddAccountPopup extends Component {

  onAddAccount = (item) => {
    localStorage.setItem('refresh', 0);
    const connectiontype = window.location.pathname.includes('connection') ? 'connectAccount' : 'socialConnect';
    showAddAccountAlertNew(item, connectiontype);
    this.props.openAddAccountPopup();
  }

  render() {
    const { addAccountPopup, openAddAccountPopup, addAccountData } = this.props
    const networksData = addAccountData;
    return <> <Modal
      size="md"
      dialogClassName="modal-dialog-centered"
      show={addAccountPopup}
      onHide={openAddAccountPopup}
    >
      <Modal.Header closeButton className='justify-content-between'>
        <Modal.Title>Pick a source</Modal.Title>

      </Modal.Header>
      <Modal.Body className='body-bg'>
        <ul className="networks modal_networks px-xl-5 mb-xl-3">
          {networksData
            ? networksData.map((item) => {
              var link = `feeds/addAccount/${item.id}`;
              var datalink = '';
              var className = 'init';
              if (item.id == 4) {
                link = '#';
                datalink = window.googlelink;
                className = 'openGoogleButton';
              }
              else if (item.id == 20) {
                link = '#';
                className = 'openSlackButton';
              }
              return <li className={item.icon}>
                <button type="button" className={`add_feed_modal ${className} hide-on-desktop`} data-network={item.id} data-user={localStorage.getItem("ownerId")} data-src={datalink} data-bs-dismiss="modal"
                  href={link} data-action="connect" onClick={() => this.onAddAccount(item)}>
                  <img className="img-fluid" src={baseUrl(`square-icons/${item.icon}.svg`)} height={50} width={50} alt="" />
                  <span>{item.name}</span>
                  <small className='fs-8'>{item.id == 18 ? '(FB Login)' : item.id == 2 ? '(Insta Login)' : ''}</small>
                </button>
              </li>
            })
            : ""}
        </ul>
      </Modal.Body>
    </Modal>

      <div style={{ display: "none" }}>
        <a href="#" className="popUp resetAction noAction googleAjaxlink noLoader" data-factors-click-bind="true">google</a><a href="#" className="popUp resetAction noAction googleAjaxReconnect noLoader" data-factors-click-bind="true">google</a></div>
    </>
  }
}

const mapStateToProps = state => {
  return {
    authorized: state?.authenticated,
  }
}


export default connect(mapStateToProps)(AddAccountPopup);
